import React, { useState, useEffect, useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { Button, Container, Row } from 'reactstrap';
import moment from 'moment';

// Services
import { getSessionCookie } from '../../../../services/session';

// Components
import Header from '../../../../components/Headers/Header';
import { faPrint } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


//Contatnts
import { relatorioStyles } from '../../../../constants/relatorioStyles';

function RelatorioProdutividadeSintetico({ handleReturn, cabecalho, relatorio }) {
    const session = getSessionCookie();

    const refImprimir = useRef();
    // Função acionada assim que o botão de imprimir é clicado
    const handlePrint = useReactToPrint({
        content: () => refImprimir.current,
        copyStyles: true,
        documentTitle: "Relatório Produtividade Sintetico",
        pageStyle: relatorioStyles
    });


    return (
        <>
            <Header />
            <Row>
                <Container className="mt--9" fluid>
                    <div className='d-flex justify-content-between align-items-center mb-1'>
                        <Button color="secondary" type="button" onClick={() => handleReturn()}>
                            Voltar
                        </Button>
                        <Button color="danger" type="button" onClick={handlePrint}>
                            <FontAwesomeIcon icon={faPrint} /> Imprimir
                        </Button>
                    </div>
                    <div className="card shadow">
                        <div className='card-body print-padding print' ref={refImprimir}>
                            <div className='row header'>
                                <div className='col-sm-12 col-lg-12 text-center print-image' style={{ display: "none" }}>
                                    <img
                                        src={require("assets/img/brand/logo.png")}
                                        alt="imagem do sistema"
                                        width={150}
                                    />
                                </div>
                                <div className='col-sm-12 col-lg-12'>
                                    <h2>Relatório Produtividade Sintético</h2>
                                </div>
                                <div className='col-sm-12 col-lg-12'>
                                    <span className='font-weight-bold'>Modalidade de Serviço: </span> <span>{cabecalho?.modalidade ?? "Todas"}</span>
                                </div>
                                <div className='col-sm-6 col-lg-6'>
                                    <span className='font-weight-bold'>Data Início:</span> <span>{cabecalho?.dataInicio && moment(cabecalho?.dataInicio).format("DD/MM/YYYY")}</span>
                                </div>
                                <div className='col-sm-6 col-lg-6'>
                                    <span className='font-weight-bold'>Data Fim:</span> <span>{cabecalho?.dataFim && moment(cabecalho?.dataFim).format("DD/MM/YYYY")}</span>
                                </div>
                            </div>
                            <div className='row'>
                                <div className={"mt-3 col-sm-12 col-lg-12"}>
                                    <div className='table-responsive'>
                                        <table className='table-bordered tabela-relatorio w-100'>
                                            <thead style={{ background: "#BEBEBE" }}>
                                                <tr>
                                                    <th>MODALIDADE</th>
                                                    <th>DIVISÃO ADMINISTRATIVA</th>
                                                    <th>PESAGEM LÍQUIDA (KG)</th>
                                                    <th>PESAGEM LÍQUIDA TOTAL (KG)</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {relatorio?.map((value, index) => (
                                                    <React.Fragment key={index}>
                                                        {/* Linha principal */}
                                                        <tr>
                                                            <td className="text-center align-middle" rowSpan={value?.divisoesAdministrativa?.length}>
                                                                {value.modalidade}
                                                            </td>
                                                            {value?.divisoesAdministrativa?.length > 0 &&
                                                                <>
                                                                    <td className="text-center">{value?.divisoesAdministrativa[0].divisaoAdministrativa}</td>
                                                                    <td className="text-center">{new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value?.divisoesAdministrativa[0].pesoLiquido)}</td>
                                                                </>
                                                            }
                                                            <td className="text-center align-middle" rowSpan={value?.divisoesAdministrativa?.length}>
                                                                {new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value.pesoLiquidoTotal)}
                                                            </td>
                                                        </tr>

                                                        {value.divisoesAdministrativa?.filter((v, index) => index != 0).map((d, dindex) => (
                                                            <tr>
                                                                <td className="text-center">{d.divisaoAdministrativa}</td>
                                                                <td className="text-center">{new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(d.pesoLiquido)}</td>
                                                            </tr>
                                                        ))}
                                                    </React.Fragment>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className='print-footer w-100 mt-2' style={{ display: "none" }}>
                                    <p className='font-weight-bold text-right'>Gerado em {moment().format("DD/MM/YYYY HH:mm")}, Por {session?.nome}.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </Container>
            </Row>
        </>
    );
}

export default RelatorioProdutividadeSintetico;
